import React, { useEffect, useMemo } from 'react';
import { Fade } from '@oneaudi/aoa-shared-editorial-components';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { VideoPlayer } from '../VideoPlayer/VideoPlayer';
import { setAssetParams } from '../../utils/setAssetParams';
import { Skeleton } from '@oneaudi/unified-web-components';
export const ResponsiveMedia = ({
  imageEnabled,
  fadeEnabled,
  fade,
  image,
  video,
  height,
  width,
  theme,
  isTest,
}) => {
  const assetParams = useMemo(
    () => setAssetParams({ image, video }, isTest, imageEnabled ? 'image' : 'video'),
    [image, video, isTest, imageEnabled],
  );
  const [isSSR, setIsSSR] = React.useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') setIsSSR(false);
  }, []);

  if (isSSR) {
    return (
      <Skeleton
        variant="rectangular"
        width={'100%'}
        height={'100%'}
        animation=""
        data-test-id="media-loader"
      />
    );
  }

  if (fadeEnabled) {
    const { color, direction, height: fadeHeight, opacity } = fade;
    return (
      <Fade
        color={color}
        direction={direction}
        height={fadeHeight}
        opacity={opacity}
        theme={theme}
        overlay
        cover
      >
        {imageEnabled ? (
          <ResponsiveImage {...assetParams.image} height={height} width={width} />
        ) : (
          <VideoPlayer
            {...assetParams.video}
            height={height}
            width={width}
            theme={theme}
            isTest={isTest}
          />
        )}
      </Fade>
    );
  }

  return imageEnabled ? (
    <ResponsiveImage {...assetParams.image} height={height} width={width} />
  ) : (
    <VideoPlayer
      {...assetParams.video}
      height={height}
      width={width}
      theme={theme}
      isTest={isTest}
    />
  );
};
